<template>
  <img
    :alt="info.logo"
    :class="className"
    :height="info.height"
    :src="info.src"
    :width="info.width"
  />
</template>

<script>
export default {
  name: 'BaseImage',
  props: {
    className: {
      type: String,
      default: '',
    },
    info: {
      type: Object,
      required: true,
    },
  },
};
</script>
